import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import Button from "./Button.js";
import { Menu, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import Link from "@mui/material/Link";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UserMenu = _ref => {
  let {
    user,
    onLogin,
    onLogout,
    links
  } = _ref;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  if (user !== null && user !== void 0 && user.isSignedIn) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, {
        id: "basic-button",
        sx: {
          textTransform: 'none'
        },
        disableElevation: true,
        variant: "contained",
        "aria-controls": open ? 'basic-menu' : undefined,
        "aria-haspopup": "true",
        "aria-expanded": open ? 'true' : undefined,
        onClick: handleClick,
        label: user.name
      }), /*#__PURE__*/_jsxs(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        MenuListProps: {
          'aria-labelledby': 'basic-button'
        },
        children: [links === null || links === void 0 ? void 0 : links.map((link, index) => {
          return /*#__PURE__*/_jsx(MenuItem, {
            children: /*#__PURE__*/_jsx(Link, {
              target: "_blank",
              href: link.href,
              rel: "noreferrer",
              onClick: handleClose,
              children: link.title
            })
          }, "usermenu_".concat(index));
        }), /*#__PURE__*/_jsx(MenuItem, {
          onClick: onLogout,
          children: "Sign Out"
        })]
      })]
    });
  } else {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onLogin,
        disableElevation: true,
        label: "Sign in"
      })
    });
  }
};
UserMenu.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    isSignedIn: PropTypes.bool
  }),
  onLogin: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string
  }))
};
UserMenu.defaultProps = {
  user: null
};
export default UserMenu;